import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { userListLoad } from "store/api/user";
import { FormItem } from "utils";
import { DataLoadComponent } from 'components/common';


class UserSelect extends DataLoadComponent {
  apiListLoad = userListLoad;

  render() {
    const { form, instance, name, label, required, errorData, disabled, onChange } = this.props;
    const { items, loadStatus } = this.state;
    const initialValue = instance && instance.id ? null : this.props.initialValue;

    return (
      <FormItem
        form={form}
        instance={instance}
        name={name}
        label={label}
        required={required}
        errorData={errorData}
        initialValue={initialValue}
      >
        <Select
          style={{ width: 200 }}
          loading={loadStatus.isLoading}
          onChange={onChange}
          showSearch={true}
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option.props.children;
            return children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }}
          disabled={disabled}
        >
          {!required && <Select.Option value={null}>---</Select.Option>}
          {items.map(item => (
            <Select.Option key={`profile${item.id}`} value={item.id}>
              {item.email}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
    );
  }
}


function mapStateToProps(state) {
  return {
    auth_token: state.auth.token,
  };
}


export default connect(mapStateToProps)(UserSelect);
